export default class DayOfWeek {
  constructor(readonly fullName: string, readonly shorthand: string) {}
}
